export default __webpack_public_path__ + "static/87-807d36f8a92fd42a662b1ca77d600b5e.jpg";